import { FormLabel } from '../../../../Common/Form'
import YPopover from '../../../../Common/Popover'

export const LimitDescBtwCostAndStock = () => (
  <>
    {'• 成本 ≥ 5萬時，數量需 ≤ 15'}
    <br />
    {'• 成本 ≥ 3萬時，數量需 ≤ 50'}
    <br />
    {'• 成本 ≥ 1萬時，數量需 ≤ 100'}
    <br />
    {'• 成本 ≥ 5千時，數量需 ≤ 300'}
    <br />
    {'• 成本 ≥ 3千時，數量需 ≤ 500'}
    <br />
    {'• 成本 ≥ 0元時，數量需 ≤ 1000'}
    <br />
  </>
)

export const IconPopoverLabel = props => {
  const {
    align,
    iconType = 'ec-information-fill',
    popoverContent,
    popoverPlacement,
    withSuffix,
    suffix,
    className
  } = props

  const formLabelTooltip = {
    component: YPopover,
    props: {
      content: popoverContent,
      placement: popoverPlacement
    }
  }

  return (
    <FormLabel
      align={align}
      iconType={iconType}
      tooltip={formLabelTooltip}
      withSuffix={withSuffix}
      suffix={suffix}
      className={className}
    >
      {props.children}
    </FormLabel>
  )
}
